"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _getEarlyRequesterResultPromise = _interopRequireDefault(require("../getEarlyRequesterResultPromise"));

var API_BASE = 'hubs/v1/settings';

var PortalSettingAPI =
/*#__PURE__*/
function () {
  function PortalSettingAPI() {
    (0, _classCallCheck2.default)(this, PortalSettingAPI);
  }

  (0, _createClass2.default)(PortalSettingAPI, null, [{
    key: "set",
    value: function set(_ref) {
      var key = _ref.key,
          value = _ref.value;
      return _apiClient.default.post(API_BASE, {
        data: {
          key: key,
          value: value,
          hub_id: _hubspot.default.get() // eslint-disable-line camelcase

        }
      });
    }
  }, {
    key: "delete",
    value: function _delete(_ref2) {
      var key = _ref2.key;
      return _apiClient.default.delete(API_BASE + "/" + _hubspot.default.get() + "/" + key);
    }
  }, {
    key: "get",
    value: function get() {
      return (0, _getEarlyRequesterResultPromise.default)('portal-settings') || _apiClient.default.get(API_BASE);
    }
  }]);
  return PortalSettingAPI;
}();

exports.default = PortalSettingAPI;
module.exports = exports.default;